import { render, staticRenderFns } from "./flecha-der.vue?vue&type=template&id=a7b5e87a&scoped=true&"
var script = {}
import style0 from "./flecha-der.vue?vue&type=style&index=0&id=a7b5e87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b5e87a",
  null
  
)

export default component.exports